import {
  GraphQLInputObjectType,
  GraphQLString,
  GraphQLList,
  GraphQLBoolean
} from 'graphql'

export interface AttackEventFilterArg {
  readonly applications?: string[]
  readonly attackers?: string[]
  readonly environments?: string[]
  readonly results?: string[]
  readonly rules?: string[]
  readonly servers?: string[]
  readonly severities?: string[]
  readonly tags?: string[]
  readonly filterText?: string
  readonly sourceNameIDs?: string[]
  readonly quickFilter?: string
  readonly startDate?: string
  readonly endDate?: string
  readonly includeBotBlockers?: boolean
  readonly includeIpBlacklist?: boolean
  readonly includeSuppressed?: boolean
}

const filterList = new GraphQLList(GraphQLString)

export const attackEventFilterArgType = new GraphQLInputObjectType({
  name: 'AttackEventFilterArg',
  description:
    'A collection of criteria categories and values to filter the attack events by. Each criteria category consists of a list of strings. Categories of criteria are applied with an AND relationship. Within each category, the individual criteria values are applied with an OR relationaship',
  fields: () => ({
    applications: {
      description: 'Filters by applications',
      type: filterList
    },
    attackers: {
      description: 'Filters by attackers',
      type: filterList
    },
    environments: {
      description: 'Filters by environments',
      type: filterList
    },
    results: {
      description: 'Filters by results',
      type: filterList
    },
    rules: {
      description: 'Filters by rules',
      type: filterList
    },
    servers: {
      description: 'Filters by servers',
      type: filterList
    },
    severities: {
      description: 'Filters by severities',
      type: filterList
    },
    tags: {
      description: 'Filters by tags',
      type: filterList
    },
    sourceNameIDs: {
      description: 'Filter by source name IDs',
      type: filterList
    },
    filterText: {
      description: 'Filter attack events that match the specified text string',
      type: GraphQLString
    },
    quickFilter: {
      description: 'An optional predefined filter',
      type: GraphQLString
    },
    startDate: {
      description: 'Filter by start date',
      type: GraphQLString
    },
    endDate: {
      description: 'Filter by end date',
      type: GraphQLString
    },
    includeBotBlockers: {
      description: 'Include bot blockers',
      type: GraphQLBoolean
    },
    includeIpBlacklist: {
      description: 'Include IP blacklist',
      type: GraphQLBoolean
    },
    includeSuppressed: {
      description: 'Include suppressed',
      type: GraphQLBoolean
    }
  })
})
